import { hasPermission, isGodRole } from "@/lib/permissions";
import type { Item } from "@/components/nav/types/nav";

/**
 * The entries this account may see. Generic in the item type so callers get
 * back what they passed in (a `NavItem[]` stays a `NavItem[]`) without a cast.
 */
export function visibleFor<T extends Item>(items: T[], roles: string[]): T[] {
  return items.filter((item) => {
    if (item.godOnly) return isGodRole(roles);
    if (!item.permission) return true;
    return hasPermission(roles, item.permission);
  });
}

/**
 * Whether `to` is the section currently on screen. A nested route keeps its
 * parent entry highlighted; "/" only matches itself so it is not always active.
 */
export function isPathActive(pathname: string, to: string): boolean {
  if (to === "/") return pathname === "/";
  return pathname === to || pathname.startsWith(`${to}/`);
}

/** Up to two initials for the account avatar. Splits emails on "@" and "." too. */
export function initials(value: string): string {
  return value
    .split(/\s+|[@.]/)
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}
